import { emitter, EventType } from './emitter.utils';

export const showLoading = (message: string) => {
  emitter.emit(EventType['modal:open-loading'], { message });
  return (afterClose?: () => void) => {
    emitter.emit(EventType['modal:close-loading'], { afterClose });
  };
};
